<template>
    <div
        class="p-4 bg-white rounded-[19px] shadow flex-col justify-start items-start gap-3 inline-flex sm:p-6">
        <div class="self-stretch">
            <div class="flex flex-wrap justify-between gap-1 md:gap-0">
                <div class="justify-start items-center gap-2 inline-flex">
                    <font-awesome-icon widthAuto v-if="props.icon" :icon="props.icon" class="text-black text-base" />
                    <div class="text-slate-700 text-xl font-extrabold">
                        <slot name="title"></slot>
                    </div>
                </div>
                <slot name="headerRight"></slot>
            </div>
        </div>
        <slot name="content"></slot>
    </div>
</template>
<script setup>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

const props = defineProps({
    icon: {
        type: Object,
        required: false,
    }
})
</script>
